module.exports = __webpack_public_path__ + "tables/media/Flaticon.76ed06ab.woff";